/* eslint-disable jsx-a11y/anchor-is-valid */
import questionLogo from '../../images/question-payment.png';

interface paymentType {
  name: string,
  per_unit_cost_description: {
      per_unit_cost: number,
      unit: string
  },
  tool_tip_note:string,
  quantity: number,
  cost: number
}
interface props {
    data: paymentType[],
    totalAmount: string|number

}
const PaymentSummary = ({ data, totalAmount }: props) => {
  const getImage = (x: string) => {
    switch (x.toLowerCase()) {
      case 'corda': return '../images/protocols/icons/corda_icon.svg';
      case 'fabric': return '../images/protocols/icons/fabric_icon.svg';
      case 'fluree': return '../images/protocols/icons/fluree_icon.svg';
      case 'ethereum': return '../images/protocols/icons/ethereum_icon.svg';
      case 'sawtooth': return '../images/protocols/icons/sawtooth_icon.svg';
      case 'phaeton': return '../images/protocols/icons/phaeton_icon.svg';
      case 'polygon': return '../images/protocols/icons/polygon_icon.svg';
      default: return '';
    }
  };
  const cloudList = ['corda', 'fabric', 'flure', 'ethereum', 'sawtooth', 'phaeton', 'polygon'];
  const checkCloud = (x:string) => {
    const val = x.split(' ')[0];
    return cloudList.includes(val.toLowerCase());
  };
  return (
    <div className="col-xl-6 col-lg-6 col-md-10 col-sm-12 mx-auto ">
    <div className="d-flex justify-content-between align-items-center">
        <p className="fw-bold mt-3">Payment Summary</p>
        <div className="dropdown">
            <span className="btn activeTextColor rounded-3 border">
                USD/month
            </span>
        </div>
    </div>
    <div className="table-responsive">
      <table className="table mt-5 TableCustom nonActiveTabColor">
          <thead className="pb-5">
            <tr style={{ lineHeight: 3 }}>
              <th scope="col">Items and Description</th>
              <th scope="col">Qty</th>
              <th scope="col">Cost</th>
            </tr>
          </thead>
          {!data && <p className="mt-3 text-center activeTextColor"><strong>No Data Available</strong></p>}
          <tbody>
            { data && data.map((d, idx) => (
              <tr key={`tabrow-${idx.toString()}`} className="TableTr">
                <td>
                  <div className="">
                    <p className="mb-0">
                      {`0${idx + 1}. ${d.name} `}
                      <span className="imageBottom"><img id="imageBottom" src={questionLogo} style={{ zIndex: 'auto' }} alt="" /></span>
                        <span className="tooltip tooltip-effect-3">
                          <span className="tooltip-content clearfix" style={{ margin: '10px -50px' }}>
                            <span className="card rounded-3">
                              <span className="card-header bg-primary rounded-top-3 text-center p-3 text-light">
                                 Protocol Pricing/ month in USDs
                              </span>
                              <span className="card-body">
                                <span className="d-flex justify-content-between align-items-center">
                                  <span className="fw-bold">
                                    { checkCloud(d.name) && <img className="protocolImage" src={getImage(d.name.split(' ')[0])} alt="" style={{ marginRight: '5px' }} />}
                                    {`${d.name} cost`}
                                  </span>
                                  <span className="fw-bold">{`$${d.per_unit_cost_description.per_unit_cost}`}</span>
                                </span>
                                <span className="mt-2 mx-2" style={{ textAlign: 'justify' }}>{`Note: ${d.tool_tip_note}`}</span>
                              </span>
                            </span>
                          </span>
                        </span>
                    </p>
                    <span className="TableSpans mx-1">{`US $${d.per_unit_cost_description.per_unit_cost} per ${d.per_unit_cost_description.unit}`}</span>
                  </div>
                </td>
                <td>{d.quantity}</td>
                <td>{`$${d.cost}`}</td>
              </tr>
            ))}
          </tbody>
      </table>
      <div className="d-flex  justify-content-between mx-2">
        <p className="fs-6 fw-bold">Total Amount</p>
        <p className="me-4 pe-5 fs-6 fw-bold">{totalAmount !== undefined ? `$${totalAmount}` : ''}</p>
      </div>
    </div>
    </div>
  );
};

export default PaymentSummary;